import React from "react";

const ProductListContext = React.createContext();

export default ProductListContext;
